import React from 'react';

import { Page, LayoutSingleColumn } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import css from './LegalPages.module.css';

const TermsOfServicePage = () => {
  return (
    <Page title="Conditions Générales d'Utilisation | Neokasa" description="Conditions générales d'utilisation de la marketplace Neokasa." scrollingDisabled={false}>
      <LayoutSingleColumn topbar={<TopbarContainer />} footer={<FooterContainer />}>
        <div className={css.root}>
          <div className={css.container}>
            <div className={css.header}>
              <h1 className={css.title}>Conditions d'Utilisation</h1>
              <p className={css.subtitle}>Conditions complètes d'utilisation de la marketplace</p>
            </div>

            <div className={css.policyContent}>
              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>1. Objet</h2>
                <p className={css.paragraph}>
                  Les présentes Conditions d'Utilisation définissent les règles applicables à l'utilisation de la plateforme (la « Marketplace »), permettant aux utilisateurs (« Acheteurs ») d'acheter des produits domotiques proposés par des vendeurs professionnels tiers (« Vendeurs »).
                </p>
                <p className={css.paragraph}>
                  La Marketplace agit en intermédiaire et non comme vendeur des produits.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>2. Fonctionnement de la Marketplace</h2>
                <p className={css.paragraph}>
                  La Marketplace permet la mise en relation entre Acheteurs et Vendeurs.
                </p>
                <p className={css.paragraph}>
                  Les contrats de vente sont conclus directement entre l'Acheteur et le Vendeur, conformément aux articles L221-1 et suivants du Code de la consommation.
                </p>
                <p className={css.paragraph}>
                  La Marketplace n'assure qu'un rôle technique.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>3. Compte Utilisateur</h2>
                <p className={css.paragraph}>
                  La création d'un compte est nécessaire pour acheter ou vendre.
                </p>
                <p className={css.paragraph}>
                  L'utilisateur s'engage à fournir des informations exactes et à maintenir la confidentialité de ses identifiants.
                </p>
                <p className={css.paragraph}>
                  L'utilisateur est responsable de toute activité réalisée depuis son compte.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>4. Rôle et Obligations des Vendeurs</h2>
                <p className={css.paragraph}>
                  Les Vendeurs sont responsables :
                </p>
                <ul className={css.list}>
                  <li className={css.listItem}>
                    de la conformité des produits vendus (articles L217-3 et suivants du Code de la consommation),
                  </li>
                  <li className={css.listItem}>
                    de la véracité des descriptions,
                  </li>
                  <li className={css.listItem}>
                    du respect des normes applicables (sécurité, marquage CE, etc.),
                  </li>
                  <li className={css.listItem}>
                    de la livraison et du service après-vente,
                  </li>
                  <li className={css.listItem}>
                    du respect du droit de rétractation lorsque applicable.
                  </li>
                </ul>
                <p className={css.paragraph}>
                  La Marketplace peut suspendre ou exclure un Vendeur en cas de non-respect des obligations légales ou contractuelles.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>5. Commandes et Paiements</h2>
                <p className={css.paragraph}>
                  Les commandes sont passées via la plateforme.
                </p>
                <p className={css.paragraph}>
                  Le paiement est traité par un prestataire sécurisé conforme à la réglementation européenne (DSP2).
                </p>
                <p className={css.paragraph}>
                  La Marketplace peut retenir temporairement les fonds jusqu'à confirmation de la bonne livraison ou résolution d'un litige.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>6. Livraison</h2>
                <p className={css.paragraph}>
                  La livraison est assurée par les Vendeurs.
                </p>
                <p className={css.paragraph}>
                  Les délais indiqués sont fournis par les Vendeurs et peuvent varier.
                </p>
                <p className={css.paragraph}>
                  L'Acheteur doit vérifier l'état du colis à réception et signaler tout problème dans les meilleurs délais.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>7. Droit de Rétractation</h2>
                <p className={css.paragraph}>
                  Conformément aux articles L221-18 et suivants du Code de la consommation, l'Acheteur peut disposer d'un délai légal de rétractation, sauf exceptions prévues par la loi.
                </p>
                <p className={css.paragraph}>
                  Les retours sont gérés par les Vendeurs, avec l'assistance de la Marketplace si nécessaire.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>8. Gestion des Litiges</h2>
                <p className={css.paragraph}>
                  En cas de problème lié à une commande, l'Acheteur doit contacter en premier lieu la Marketplace, via le support dédié.
                </p>
                <p className={css.paragraph}>
                  La Marketplace analysera la situation et assurera un rôle de médiation auprès du Vendeur.
                </p>
                <p className={css.paragraph}>
                  La Marketplace ne garantit pas la résolution du litige et ne peut être tenue responsable des obligations légales du Vendeur.
                </p>
                <p className={css.paragraph}>
                  Si la résolution échoue, l'Acheteur peut recourir à une médiation de la consommation conformément à l'article L612-1 du Code de la consommation.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>9. Responsabilités</h2>
                <p className={css.paragraph}>
                  La Marketplace n'est pas responsable des produits, de leur sécurité ou de leur conformité.
                </p>
                <p className={css.paragraph}>
                  L'Acheteur reconnaît que toute réclamation relative au produit (défaut, conformité, garantie légale) doit légalement être dirigée contre le Vendeur.
                </p>
                <p className={css.paragraph}>
                  La Marketplace peut suspendre ou supprimer un compte en cas d'abus ou de violation des présentes Conditions.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>10. Données Personnelles</h2>
                <p className={css.paragraph}>
                  La Marketplace collecte et traite certaines données personnelles dans le cadre de son fonctionnement, conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.
                </p>
                <p className={css.paragraph}>
                  Les détails sont fournis dans la Politique de Confidentialité.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>11. Modification des Conditions</h2>
                <p className={css.paragraph}>
                  La Marketplace peut modifier les présentes Conditions à tout moment.
                </p>
                <p className={css.paragraph}>
                  Les modifications seront notifiées aux utilisateurs et entreront en vigueur à compter de leur publication, sauf mention contraire.
                </p>
              </section>

              <section className={css.policySection}>
                <h2 className={css.sectionTitle}>12. Droit Applicable et Juridiction</h2>
                <p className={css.paragraph}>
                  Les présentes Conditions sont soumises au droit français.
                </p>
                <p className={css.paragraph}>
                  En cas de litige non résolu à l'amiable ou par médiation, les tribunaux français seront seuls compétents.
                </p>
              </section>
            </div>

            <div className={css.contactSection}>
              <h2 className={css.contactTitle}>Besoin d'aide concernant les Conditions d'Utilisation ?</h2>
              <p className={css.contactText}>
                Pour toute question concernant les conditions d'utilisation, votre compte ou l'utilisation de la marketplace, notre équipe d'assistance est à votre disposition.
              </p>
              <div className={css.contactButtons}>
                <a href="/contact" className={css.contactButton}>
                  Contacter le support
                </a>
                <a href="mailto:contact@neokasa.fr" className={css.contactButtonSecondary}>
                  Assistance par e-mail
                </a>
              </div>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

export default TermsOfServicePage;


